import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import './team.scss';

const TeamSection = ({ payload }) => {
  const { team } = payload;
  const { t } = useTranslation();

  if (!team) return null;

  return (
    <section className="team">
      <div className="team__container">
        <div>
          <h2>{t(team.title)}</h2>
          {team.paragraphs?.map((p, index) => (
            <p key={index} dangerouslySetInnerHTML={{ __html: t(p) }} />
          ))}
          {team.cta && (
            <div className="flex__class--rowLeft">
              <a className="button--secondary" href={team.cta.href}>
                {t(team.cta.label)}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;